





















































import { Component, Vue, Watch, Emit, Prop } from 'vue-property-decorator';
@Component
export default class VariableTableList extends Vue {
  @Prop() private variableList!: any;
}
